module.exports = __webpack_public_path__ + "img/milva-logo-subline-green.acedd4c6.svg";